import { Action, createReducer, on, State } from '@ngrx/store';
import {
  MediaTypeResponse,
  PrinterModelFleetSummaryItem,
  PrinterModelItem,
  PrinterModelListReponse,
} from '../../../api/models';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { printerModelActions } from './printer-model.actions';

export interface PrinterModelState {
  printerModel: {
    state: ILoaderActionPayload;
    data?: PrinterModelListReponse;
  };
  selectOnePrinterModel: {
    state: ILoaderActionPayload;
    data?: PrinterModelItem;
  };
  updatePrinterModel: {
    state: ILoaderActionPayload;
    data?: PrinterModelItem;
  };
  loadFilesTypes: {
    state: ILoaderActionPayload;
    data?: MediaTypeResponse;
  };
  loadPrintersCountByModel: {
    state: ILoaderActionPayload;
    data?: PrinterModelFleetSummaryItem;
  };
}
const initialState: PrinterModelState = {
  printerModel: { state: { value: LoadingState.NONE } },
  selectOnePrinterModel: { state: { value: LoadingState.NONE } },
  updatePrinterModel: { state: { value: LoadingState.NONE } },
  loadFilesTypes: { state: { value: LoadingState.NONE } },
  loadPrintersCountByModel: { state: { value: LoadingState.NONE } },
};
const reducer = createReducer(
  initialState,
  //lista modelli
  on(printerModelActions.loadPrinterModel, (state) => ({
    ...state,
    printerModel: { state: { value: LoadingState.LOADING } },
  })),
  on(printerModelActions.loadPrinterModelDone, (state, props) => ({
    ...state,
    printerModel: { state: props.state, data: props.data },
  })),
  //un modello
  on(printerModelActions.loadOnePrinterModel, (state) => ({
    ...state,
    selectOnePrinterModel: { state: { value: LoadingState.LOADING } },
  })),
  on(printerModelActions.loadOnePrinterModelDone, (state, props) => ({
    ...state,
    selectOnePrinterModel: { state: props.state, data: props.data },
  })),
  on(printerModelActions.updateModel, (state) => ({
    ...state,
    labelName: { state: { value: LoadingState.LOADING } },
  })),
  on(printerModelActions.updateModelDone, (state, props) => ({
    ...state,
    labelName: { state: props.state, data: props.data },
  })),
  on(printerModelActions.loadFileTypes, (state) => ({
    ...state,
    loadFilesTypes: { state: { value: LoadingState.LOADING } },
  })),
  on(printerModelActions.loadFileTypesDone, (state, props) => ({
    ...state,
    loadFilesTypes: { state: props.state, data: props.data },
  })),
  on(printerModelActions.loadPrintersCountByModel, (state) => ({
    ...state,
    loadPrintersCountByModel: { state: { value: LoadingState.LOADING } },
  })),
  on(printerModelActions.loadPrintersCountByModelDone, (state, props) => ({
    ...state,
    loadPrintersCountByModel: { state: props.state, data: props.data },
  })),
);
export function printerModelReducer(state: PrinterModelState | undefined, action: Action) {
  return reducer(state, action);
}
